<div class="w-full">
	<div class="mt-5 ml-5 md:ml-20 md:mt-0 w-10 h-10">
		<button (click)="backClicked()">
			<img src="../../../../assets/icons/arrow-left-primary.svg" alt="Voltar" class="w-10 h-10">
		</button>
	</div>
</div>
